import { Box } from "@outschool/backpack";
import { useProductListViewed } from "@outschool/ui-analytics";
import { useSession } from "@outschool/ui-auth";
import { Container } from "@outschool/ui-legacy-component-library";
import React from "react";

import useConcierge from "../../../hooks/useConcierge";
import { useSearchFilters } from "../../../lib/useSearchFilters";
import { ActivityListing } from "../../listings/ActivityListing";
import { ListingsProp } from "../common";
import { GetClassRecommendationsChatButton } from "../GetClassRecommendations";

export function ListingsWrapper({
  listings,
  tracking: {
    // @ts-ignore
    startIndex = 0,
    // @ts-ignore
    searchUid = null,
    // @ts-ignore
    group = null,
    // @ts-ignore
    numPopular = 0
  },
  disabled = false
}: ListingsProp) {
  const trackProductListViewed = useProductListViewed();
  const [index, setIndex] = React.useState(0);
  const [page, setPage] = React.useState(1);
  const { filters } = useSearchFilters();
  const { isLoggedIn } = useSession();
  const { shouldShowConciergeEntry } = useConcierge();
  const hasFilters =
    filters && Object.values(filters).some(value => value !== undefined);

  const hasPublicFundingFilter = (filters?.fundingPrograms || []).length > 0;
  React.useEffect(() => {
    if (index === listings.length) {
      return;
    }

    trackProductListViewed(
      "search",
      `${group}-${page}`,
      // @ts-ignore TS(2345): Argument of type '{ __typename?: "Listing" | undef... Remove this comment to see the full error message
      listings.slice(index, listings.length)
    );
    setIndex(listings.length);
    setPage(page + 1);
  }, [group, index, listings, page, trackProductListViewed]);

  const hasListingsAndFilters = listings.length > 1 && hasFilters;
  return (
    <Container
      sx={{
        marginBottom: "1em"
      }}
    >
      {listings.map((listing, index) => (
        <Box key={listing.activity.uid}>
          <ActivityListing
            listing={listing}
            listingIndex={index}
            trackingProperties={{
              searchUid,
              group,
              isPopular: (index < numPopular).toString(),
              order: startIndex + index + 1,
              rank_strategy: listing.strategy,
              rank_es_score: listing.score,
              rank_strategy_score: listing.strategyScore,
              rank_randomized_score: listing.strategy?.startsWith("popular")
                ? // @ts-ignore TS(2531): Object is possibly 'null'.
                  listing.score - listing.strategyScore
                : null
            }}
            disabled={disabled}
            openInNewTab
            showFundingBadge={hasPublicFundingFilter}
          />
        </Box>
      ))}

      {!!hasListingsAndFilters && isLoggedIn && !shouldShowConciergeEntry && (
        <GetClassRecommendationsChatButton />
      )}
    </Container>
  );
}
